

















import { Vue, Component, Prop } from 'nuxt-property-decorator';

import HeaderMenuNotificationsCardGrid from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import HeaderMenuNotificationsCardGridLogo from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridLogo.vue';
import HeaderMenuNotificationsCardGridAvatar from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridAvatar/HeaderMenuNotificationsCardGridAvatar.vue';
import { notificationTypes } from '@/components/global/HeaderMenu/HeaderMenuNotifications/constants';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

import MoneyStackIcon from '~/assets/svg/money-stack.vue.svg';
import type { JobsHiring, Notification } from '~/types/graphql';

@Component({
  components: {
    BravadoButtonV3,
    HeaderMenuNotificationsCardGrid,
    HeaderMenuNotificationsCardGridLogo,
    HeaderMenuNotificationsCardGridAvatar,
    MoneyStackIcon,
  },
})
export default class HeaderMenuNotificationsCardJobIntroduction extends Vue {
  @Prop() notification!: Notification;

  get hiring() {
    return this.notification.referenceable as JobsHiring;
  }

  get titleText() {
    return `You have been introduced to
      ${this.hiring.vacancy?.primaryRecruiter?.firstname} at
      ${this.company.name}.
      Click to schedule your interview!`;
  }

  get company() {
    return this.hiring.employer.company;
  }
}
